<template>
	<layout-gestao>
		<notification-details
			:moduleId="moduleCode"
			:componentId="pageID"
		/>
	</layout-gestao>
</template>

<script>
	import layout from '../../../../layouts/Main.vue';
	import ModuleMixin from '../../../../shared/mixins/ModuleMixin';

	export default {
		components: {
			layoutGestao: layout,
			NotificationDetails: () => import(/* webpackChunkName: "notification-details" */ '@/app/shared/components/manage/notification/ManageNotificationDetails'),
		},
		mixins: [
			ModuleMixin,
		],
		data() {
			return {
				pageID: 'parish_interventions_notifications',
			}
		},
	}
</script>
